import trackPerformance from './trackPerformance';
import WeapiEventPayload from './contracts/weapiEventPayload';

export { trackPerformance as default, WeapiEventPayload };
